module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team"
  }, [_c('div', {
    staticClass: "top-buttons"
  }, [_c('h1', {
    staticClass: "heading"
  }, [(_vm.isStart) ? _c('span', [_vm._v("\n              Add Players to Start\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isStart) ? _c('span', [_vm._v("\n              Add or Change Players\n            ")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "players-ul"
  }, _vm._l((_vm.playersWithNew), function(player) {
    return _c('li', {
      key: player.id,
      staticClass: "players-li",
      class: {
        'player-editing': player == _vm.editingName || player.playerName === ''
      }
    }, [_c('div', {
      staticClass: "player-name"
    }, [_c('span', {
      staticClass: "player-name-text",
      on: {
        "click": function($event) {
          _vm.editPlayer(player)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(player.playerName) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "player-delete",
      on: {
        "click": function($event) {
          _vm.deletePlayer(player)
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (player.playerName),
        expression: "player.playerName"
      }, {
        name: "player-focus",
        rawName: "v-player-focus",
        value: (player == _vm.editingName),
        expression: "player == editingName"
      }],
      staticClass: "player-edit",
      attrs: {
        "type": "text",
        "placeholder": _vm.newPlaceholder(player)
      },
      domProps: {
        "value": (player.playerName)
      },
      on: {
        "blur": function($event) {
          _vm.doneEdit(player)
        },
        "keyup": [function($event) {
          _vm.editPlayer(player)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.doneEdit(player, true)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
          _vm.cancelEdit(player)
        }],
        "click": function($event) {
          _vm.editPlayer(player)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(player, "playerName", $event.target.value)
        }
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72ef3002","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 26
// module chunks = 0